var render = function () {
  var _vm$currentStep, _vm$currentStep$activ, _vm$currentStep$activ2, _vm$currentStep2, _vm$currentStep2$acti, _vm$currentStep2$acti2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'starts-with'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "steps-container"
  }, [_c('figure', {
    staticClass: "step-image"
  }, [(_vm$currentStep = _vm.currentStep) !== null && _vm$currentStep !== void 0 && (_vm$currentStep$activ = _vm$currentStep.activityImage) !== null && _vm$currentStep$activ !== void 0 && (_vm$currentStep$activ2 = _vm$currentStep$activ.image) !== null && _vm$currentStep$activ2 !== void 0 && _vm$currentStep$activ2.src ? _c('img', {
    attrs: {
      "alt": "Main step image",
      "src": (_vm$currentStep2 = _vm.currentStep) === null || _vm$currentStep2 === void 0 ? void 0 : (_vm$currentStep2$acti = _vm$currentStep2.activityImage) === null || _vm$currentStep2$acti === void 0 ? void 0 : (_vm$currentStep2$acti2 = _vm$currentStep2$acti.image) === null || _vm$currentStep2$acti2 === void 0 ? void 0 : _vm$currentStep2$acti2.src
    }
  }) : _vm._e()]), _c('text-display-list', {
    staticClass: "text-steps",
    attrs: {
      "text-size": _vm.textSize
    }
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    return _c('li', {
      key: ((_vm.progress.roundIndex) + "-" + stepIndex),
      class: ("step step-" + stepIndex)
    }, [_c('color-block-text', {
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    })], 1);
  }), 0)], 1)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }